"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Unattempted_exports = {};
__export(Unattempted_exports, {
  default: () => Unattempted_default
});
module.exports = __toCommonJS(Unattempted_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.9243 10.9242C15.1586 10.6899 15.1586 10.31 14.9243 10.0756C14.6899 9.84132 14.31 9.84132 14.0757 10.0756L11.9999 12.1515L9.92426 10.0758C9.68994 9.84152 9.31004 9.84152 9.07573 10.0758C8.84141 10.3101 8.84141 10.69 9.07573 10.9244L11.1514 13L9.07573 15.0756C8.84142 15.31 8.84142 15.6899 9.07573 15.9242C9.31004 16.1585 9.68994 16.1585 9.92426 15.9242L11.9999 13.8485L14.0757 15.9244C14.31 16.1587 14.6899 16.1587 14.9243 15.9244C15.1586 15.69 15.1586 15.3101 14.9243 15.0758L12.8484 13L14.9243 10.9242Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9 3.5H6C4.89543 3.5 4 4.39543 4 5.5V19.5C4 20.6046 4.89543 21.5 6 21.5H18C19.1046 21.5 20 20.6046 20 19.5V5.5C20 4.39543 19.1046 3.5 18 3.5H15V4.5C15 4.56781 14.9955 4.63457 14.9868 4.7H18C18.4418 4.7 18.8 5.05817 18.8 5.5V19.5C18.8 19.9418 18.4418 20.3 18 20.3H6C5.55817 20.3 5.2 19.9418 5.2 19.5V5.5C5.2 5.05817 5.55817 4.7 6 4.7H9.01322C9.0045 4.63457 9 4.56781 9 4.5V3.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.8 4.5V3.5C14.8 3.33431 14.6657 3.2 14.5 3.2H9.5C9.33431 3.2 9.2 3.33431 9.2 3.5V4.5C9.2 4.66569 9.33431 4.8 9.5 4.8H14.5C14.6657 4.8 14.8 4.66569 14.8 4.5ZM9.5 2C8.67157 2 8 2.67157 8 3.5V4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5V3.5C16 2.67157 15.3284 2 14.5 2H9.5Z",
      fill: "currentColor"
    }
  )
);
const SvgUnattempted = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Unattempted_default = SvgUnattempted;
